import { imgPhoneCamera } from "@/shared/assets/img";
import { Battery3Icon, SignalIcon, WifiIcon } from "@/shared/icons";

type Props = {
  hours: string;
  minutes: string;
};

export default function PhoneHeader({ hours, minutes }: Props) {
  return (
    <div className="relative flex w-full items-center mb-7.5 mt-3 px-6.5">
      <p className="text-13 font-medium">
        {hours}:{minutes}
      </p>
      <div
        className="absolute top-1/2 left-1/2 w-[6rem] h-7 bg-no-repeat bg-cover -translate-y-1/2 -translate-x-1/2"
        style={{
          backgroundImage: `url(${imgPhoneCamera})`,
        }}
      />
      <div className="flex items-center gap-1.5 ml-auto">
        <SignalIcon className="size-4.5" />
        <WifiIcon className="size-4" />
        <Battery3Icon className="size-6" />
      </div>
    </div>
  );
}
